import * as Actions from "./constants";
import { put, call, takeEvery, takeLatest } from "redux-saga/effects";
import { getSubscription, getSubscriptionByID, createPaymentIntent, createOrder, getPriceById } from "../subscriptionWeb/service";

/**
 * Get all subscription
 */
function* subscription(id) {
  try {
    const { data } = yield call(getSubscription, id);
    yield put({
      type: Actions.GET_SUBSCRIPTION_SUCCESS,
      payload: data.plans,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_SUBSCRIPTION_FAIL,
      payload: error.message,
    });
  }
}

/**
 * Get all subscription by it's id
 */
function* subscriptionByID({ subscriptionID }) {
  try {
    const { data } = yield call(getSubscriptionByID, subscriptionID);
    yield put({
      type: Actions.GET_SUBSCRIPTION_BY_ID_SUCCESS,
      payload: data.plan,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_SUBSCRIPTION_BY_ID_ERROR,
      payload: error.message,
    });
  }
}
/**
 * Get price by id
 */
function* getPriceByIds({ priceId }) {
  try {
    const { data } = yield call(getPriceById, priceId);
    yield put({
      type: Actions.GET_PRICE_BY_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_PRICE_BY_ID_ERROR,
      payload: error.message,
    });
  }
}
/**
 * Create Order
 */
function* subscriptionOrderCreate({ postData }) {
  try {
    const { session } = yield call(createOrder, postData);
    yield put({
      type: Actions.CREATE_ORDER_SUCCESS,
      payload: session,
    });
  } catch (error) {
    yield put({
      type: Actions.CREATE_ORDER_ERROR,
      payload: error.message,
    });
  }
}
/**
 * Create payment intent
 */
function* paymentIntent({ items }) {
  try {
    const { data } = yield call(createPaymentIntent, items);
    yield put({
      type: Actions.PAYMENT_INTENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.PAYMENT_INTENT_ERROR,
      payload: error.message,
    });
  }
}

export default function* subscriptionSaga() {
  yield takeEvery(Actions.GET_SUBSCRIPTION, subscription);
  yield takeEvery(Actions.GET_PRICE_BY_ID, getPriceByIds);
  yield takeEvery(Actions.GET_SUBSCRIPTION_BY_ID, subscriptionByID);
  yield takeEvery(Actions.PAYMENT_INTENT, paymentIntent);
  yield takeEvery(Actions.CREATE_ORDER, subscriptionOrderCreate);
}
